import { SENSORS } from '../config';

export function findTimeSinceLastReading(metrics) {
  const timestamps = metrics
    .map((reading) => new Date(reading.timestamp))
    .filter((date) => !isNaN(date.getTime()));

  if (timestamps.length === 0) {
    return Infinity;
  }
  let latestTimestamp = timestamps.reduce((a, b) => {
    return Math.max(a, b);
  });

  // If all elements are the same, no max can be found
  if (!latestTimestamp) {
    latestTimestamp = timestamps[0];
  }

  // Some metrics don't contain timestamps, causing the dates to be invalid
  if (isNaN(latestTimestamp)) {
    return Infinity;
  }

  const currentTimestamp = new Date();
  return Math.round((currentTimestamp - latestTimestamp) / (1000 * 60));
}

export function findSensorValue(metrics, sensorType, unit) {
  if (metrics) {
    const sensor = metrics.find(
      (sensor) => sensor.sensorType === sensorType && sensor.value !== undefined
    );
    if (sensor) {
      return Math.round(sensor.value * 100) / 100 + unit;
    }
  }

  return 'No value';
}

export function findHighestAndLowestReadingsFromSensor(
  numberOfReadings,
  readings,
  sensor
) {
  const allReadings = readings.filter(
    (reading) => reading.sensorType === sensor.name && reading.value
  );
  allReadings.sort((a, b) => a.value - b.value);

  // For voltage measurements, the largest one is always the system
  let highest;
  if (sensor.name === SENSORS.Voltage.name) {
    highest = allReadings.slice(-(numberOfReadings + 1), -1);
  } else {
    highest = allReadings.slice(-numberOfReadings);
  }
  const lowest = allReadings.slice(0, numberOfReadings);

  return { highest, lowest };
}
